import { FullscreenLoaderService } from 'components/fullscreenLoader/fullscreenLoader.service';
import { AuthService } from 'services/auth.service';

import template from './logoutButton.html';
import './logoutButton.scss';

export const LogoutButton = angular
    .module('checkout.components.logoutButton', [
        FullscreenLoaderService,
        AuthService
    ]).component('logoutButton', {
        template,
        bindings: {
            nameText: '<',
            smallWelcomeText: '<',
            useNewCarts: '<'
        },
        controller: class LogoutButtonCtrl {
            constructor(authService, loadingService) {
                this.authService = authService;
                this.loadingService = loadingService;
            }
            onLogoutClicked() {
                this.loadingService.show('Logging out...');
                this.authService.logout(this.useNewCarts);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/logoutButton/logoutButton.js